/* IUTIENDA.COM — Theme JS */
(function() {
  'use strict';

  // ====== PRELOADER ======
  window.addEventListener('load', () => {
    const p = document.getElementById('preloader');
    if (p) { p.classList.add('hidden'); setTimeout(() => p.remove(), 600); }
  });

  // ====== HERO SLIDER ======
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.hero-dot');
  let current = 0, autoplayInterval;
  if (slides.length > 1) {
    function goTo(i) {
      slides[current].classList.remove('active');
      dots[current]?.classList.remove('active');
      current = (i + slides.length) % slides.length;
      slides[current].classList.add('active');
      dots[current]?.classList.add('active');
    }
    function startAuto() { autoplayInterval = setInterval(() => goTo(current + 1), 5000); }
    function stopAuto() { clearInterval(autoplayInterval); }
    document.getElementById('hero-prev')?.addEventListener('click', () => { stopAuto(); goTo(current - 1); startAuto(); });
    document.getElementById('hero-next')?.addEventListener('click', () => { stopAuto(); goTo(current + 1); startAuto(); });
    dots.forEach((d, i) => d.addEventListener('click', () => { stopAuto(); goTo(i); startAuto(); }));
    startAuto();
  }

  // ====== CART DRAWER ======
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  function openCart() { cartDrawer?.classList.add('open'); cartOverlay?.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeCart() { cartDrawer?.classList.remove('open'); cartOverlay?.classList.remove('open'); document.body.style.overflow = ''; }
  document.getElementById('cart-toggle')?.addEventListener('click', openCart);
  document.getElementById('cart-drawer-close')?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  // Add to Cart via AJAX
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.add-to-cart-btn');
    if (!btn) return;
    const form = btn.closest('form');
    if (!form) return;
    e.preventDefault();
    btn.classList.add('loading');
    btn.disabled = true;
    const oldText = btn.innerHTML;
    btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Agregando...';

    const variantInput = form.querySelector('#variant-id, [name="id"]');
    const qtyInput = form.querySelector('#qty-input, [name="quantity"]');
    const variantId = variantInput ? variantInput.value : null;
    const quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    const debugEl = document.getElementById('variant-debug');
    if (debugEl) {
      console.log('[IUTIENDA DEBUG] variant_id:', variantId, 'available:', debugEl.dataset.available, 'inventory:', debugEl.dataset.inventory, 'policy:', debugEl.dataset.policy);
    }

    if (!variantId) {
      btn.innerHTML = oldText;
      btn.classList.remove('loading');
      btn.disabled = false;
      alert('Este producto no tiene una variante disponible.');
      return;
    }

    const formData = new FormData(form);
    formData.set('id', variantId);
    formData.set('quantity', quantity);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(async (r) => {
        const body = await r.json().catch(() => ({}));
        if (!r.ok) {
          throw new Error(body.description || body.message || 'No se pudo agregar al carrito');
        }
        return body;
      })
      .then(() => {
        btn.innerHTML = '<i class="fas fa-check"></i> ¡Agregado!';
        btn.classList.remove('loading');
        btn.disabled = false;
        updateCartDrawer();
        setTimeout(() => { btn.innerHTML = oldText; openCart(); }, 800);
      })
      .catch((err) => {
        btn.innerHTML = oldText;
        btn.classList.remove('loading');
        btn.disabled = false;
        console.error('Add to cart error:', err);
        alert('No se pudo agregar al carrito: ' + (err.message || 'intenta de nuevo') + '\n\n[Debug] Variant ID enviado: ' + variantId);
      });
  });

  // Buy Now via AJAX: add to cart then go to checkout
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-buy-now="true"]');
    if (!btn) return;
    const form = btn.closest('form');
    if (!form) return;
    e.preventDefault();
    const oldText = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Procesando...';

    const variantInput = form.querySelector('#variant-id, [name="id"]');
    const qtyInput = form.querySelector('#qty-input, [name="quantity"]');
    const variantId = variantInput ? variantInput.value : null;
    const quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    if (!variantId) {
      btn.disabled = false;
      btn.innerHTML = oldText;
      alert('Este producto no tiene una variante disponible para comprar.');
      return;
    }

    const formData = new FormData(form);
    formData.set('id', variantId);
    formData.set('quantity', quantity);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(async (r) => {
        const body = await r.json().catch(() => ({}));
        if (!r.ok) {
          throw new Error(body.description || body.message || 'add to cart failed');
        }
        return body;
      })
      .then(() => { window.location.href = '/checkout'; })
      .catch((err) => {
        btn.disabled = false;
        btn.innerHTML = oldText;
        console.error('Buy now error:', err);
        alert('No se pudo procesar la compra: ' + (err.message || 'intenta de nuevo') + '. Puedes usar "Agregar al Carrito" como alternativa.');
      });
  });

  function updateCartDrawer() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const badge = document.getElementById('cart-badge');
        if (badge) badge.textContent = cart.item_count;
        const countEl = document.querySelector('.cart-drawer__count');
        if (countEl) countEl.textContent = `(${cart.item_count})`;
        const totalEl = document.querySelector('.cart-drawer__subtotal strong');
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
        updateShippingBar(cart);
        renderCartItems(cart);
        renderRecommendations(cart);
      });
  }

  // ====== FREE SHIPPING PROGRESS BAR ======
  function updateShippingBar(cart) {
    const bar = document.getElementById('cart-shipping-bar');
    const text = document.getElementById('cart-shipping-text');
    const fill = document.getElementById('cart-shipping-fill');
    if (!bar || !text || !fill) return;

    const goal = parseInt(bar.dataset.goal, 10) || 30000000;
    const remaining = goal - cart.total_price;
    const progress = Math.min(100, (cart.total_price / goal) * 100);
    fill.style.width = progress + '%';

    if (remaining > 0) {
      text.classList.remove('cart-shipping-bar__text--success');
      text.innerHTML = `Gasta <strong>${formatMoney(remaining)}</strong> más para disfrutar <strong>¡Envío gratis!</strong>`;
    } else {
      text.classList.add('cart-shipping-bar__text--success');
      text.innerHTML = '<i class="fas fa-check-circle"></i> ¡Felicidades! Tienes envío gratis';
    }
  }

  // ====== CROSS-SELL RECOMMENDATIONS ======
  function renderRecommendations(cart) {
    const container = document.getElementById('cart-drawer-recommendations');
    if (!container) return;
    if (cart.item_count === 0) {
      container.innerHTML = '';
      return;
    }
    // Use the last item added as the basis for recommendations
    const lastItem = cart.items[cart.items.length - 1];
    const productId = lastItem.product_id;
    fetch(`/recommendations/products.json?product_id=${productId}&limit=4&intent=related`)
      .then(r => r.json())
      .then(data => {
        const products = (data.products || []).filter(p => {
          // Don't recommend items already in cart
          return !cart.items.some(item => item.product_id === p.id);
        }).slice(0, 3);

        if (products.length === 0) {
          container.innerHTML = '';
          return;
        }

        container.innerHTML = `
          <div class="cart-recommendations__title">También te puede interesar</div>
          <div class="cart-recommendations__list">
            ${products.map(p => `
              <div class="cart-recommendation">
                <a href="${p.url}" class="cart-recommendation__image">
                  ${p.featured_image ? `<img src="${p.featured_image}" alt="${p.title}">` : `<div class="product-card__no-image"><i class="fas fa-tools"></i></div>`}
                </a>
                <div class="cart-recommendation__info">
                  <a href="${p.url}" class="cart-recommendation__title">${p.title.substring(0, 45)}${p.title.length > 45 ? '...' : ''}</a>
                  <span class="cart-recommendation__price">${formatMoney(p.price)}</span>
                </div>
                <button class="cart-recommendation__add" data-variant-id="${p.variants[0].id}" aria-label="Agregar al carrito">
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            `).join('')}
          </div>
        `;
      })
      .catch(() => { container.innerHTML = ''; });
  }

  // Add recommended product to cart
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.cart-recommendation__add');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    btn.disabled = true;
    btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(r => r.json())
      .then(() => { updateCartDrawer(); })
      .catch(() => { btn.disabled = false; btn.innerHTML = '<i class="fas fa-plus"></i>'; });
  });

  // Load recommendations on initial page load (handles empty cart gracefully)
  document.addEventListener('DOMContentLoaded', () => {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      renderRecommendations(cart);
      updateShippingBar(cart);
    }).catch(() => {});
  });

  function renderCartItems(cart) {
    const body = document.getElementById('cart-drawer-body');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = `<div class="cart-empty"><i class="fas fa-shopping-cart"></i><p>Tu carrito está vacío</p><a href="/collections/all" class="btn btn--primary">Ver Productos</a></div>`;
      return;
    }
    body.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__image"><img src="${item.image}" alt="${item.title}"></div>
        <div class="cart-item__info">
          <a href="${item.url}" class="cart-item__title">${item.title.substring(0, 40)}${item.title.length > 40 ? '...' : ''}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
          <div class="cart-item__price-row">
            <span class="cart-item__qty">${item.quantity}x</span>
            <span class="cart-item__price">${formatMoney(item.final_line_price)}</span>
          </div>
        </div>
        <button class="cart-item__remove" data-key="${item.key}"><i class="fas fa-trash"></i></button>
      </div>`).join('');
  }

  document.addEventListener('click', (e) => {
    const rm = e.target.closest('.cart-item__remove');
    if (!rm) return;
    const key = rm.dataset.key;
    fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({id: key, quantity: 0}) })
      .then(r => r.json()).then(updateCartDrawer);
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('es-CO');
  }

  // ====== MOBILE MENU ======
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileOverlay = document.getElementById('mobile-overlay');
  document.getElementById('mobile-toggle')?.addEventListener('click', () => { mobileMenu?.classList.add('open'); mobileOverlay?.classList.add('open'); document.body.style.overflow = 'hidden'; });
  const closeMobile = () => { mobileMenu?.classList.remove('open'); mobileOverlay?.classList.remove('open'); document.body.style.overflow = ''; };
  document.getElementById('mobile-menu-close')?.addEventListener('click', closeMobile);
  mobileOverlay?.addEventListener('click', closeMobile);

  document.querySelectorAll('.mobile-nav__toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const parent = btn.closest('.mobile-nav__parent');
      const isOpen = parent.classList.contains('open');
      document.querySelectorAll('.mobile-nav__parent').forEach(p => p.classList.remove('open'));
      if (!isOpen) parent.classList.add('open');
    });
  });

  // ====== QUICK VIEW ======
  const qvOverlay = document.getElementById('quickview-overlay');
  const qvModal = document.getElementById('quickview-modal');
  const qvContent = document.getElementById('quickview-content');
  function closeQV() { qvModal?.classList.remove('open'); qvOverlay?.classList.remove('open'); document.body.style.overflow = ''; }
  qvOverlay?.addEventListener('click', closeQV);
  document.getElementById('quickview-close')?.addEventListener('click', closeQV);
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.quickview-btn');
    if (!btn) return;
    const url = btn.dataset.productUrl;
    if (!url || !qvContent) return;
    qvContent.innerHTML = '<div style="padding:40px;text-align:center;"><i class="fas fa-spinner fa-spin" style="font-size:32px;color:var(--color-primary)"></i></div>';
    qvModal?.classList.add('open'); qvOverlay?.classList.add('open'); document.body.style.overflow = 'hidden';
    fetch(url + '?view=quickview')
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const content = doc.querySelector('.product-layout') || doc.querySelector('main');
        qvContent.innerHTML = content ? content.innerHTML : '<p style="padding:30px">Ver producto completo.</p>';
      })
      .catch(() => { qvContent.innerHTML = `<div style="padding:30px;text-align:center"><a href="${url}" class="btn btn--primary">Ver Producto</a></div>`; });
  });

  // ====== GALLERY THUMBS ======
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('.gallery-thumb');
    if (!thumb) return;
    const mainImg = document.getElementById('main-image');
    if (mainImg) mainImg.src = thumb.dataset.src;
    document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });

  // ====== PRODUCT QUANTITY ======
  document.querySelector('.qty-minus')?.addEventListener('click', () => {
    const input = document.getElementById('qty-input');
    if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
  });
  document.querySelector('.qty-plus')?.addEventListener('click', () => {
    const input = document.getElementById('qty-input');
    if (input) input.value = parseInt(input.value) + 1;
  });

  // ====== PRODUCT TABS ======
  document.querySelectorAll('.product-tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const tab = btn.dataset.tab;
      document.querySelectorAll('.product-tab-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.product-tab-content').forEach(c => c.classList.remove('active'));
      btn.classList.add('active');
      document.getElementById(`tab-${tab}`)?.classList.add('active');
    });
  });

  // ====== COLLECTION FILTER TOGGLE ======
  document.getElementById('filter-toggle')?.addEventListener('click', () => {
    document.querySelector('.collection-sidebar')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
  document.getElementById('sidebar-close')?.addEventListener('click', () => {
    document.querySelector('.collection-sidebar')?.classList.remove('open');
    document.body.style.overflow = '';
  });

  // ====== COLLECTION PRICE & STOCK FILTER ======
  (function() {
    const priceMin = document.getElementById('price-min');
    const priceMax = document.getElementById('price-max');
    const priceMinLabel = document.getElementById('price-min-label');
    const priceMaxLabel = document.getElementById('price-max-label');
    const applyBtn = document.getElementById('apply-price-filter');
    const stockCheckbox = document.getElementById('filter-instock');
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    function formatCOP(n) {
      return '$' + Math.round(n).toLocaleString('es-CO');
    }

    function updateLabels() {
      if (priceMin && priceMinLabel) priceMinLabel.textContent = formatCOP(priceMin.value);
      if (priceMax && priceMaxLabel) priceMaxLabel.textContent = formatCOP(priceMax.value);
    }

    // Keep min <= max while dragging
    priceMin?.addEventListener('input', () => {
      if (priceMax && parseInt(priceMin.value) > parseInt(priceMax.value)) {
        priceMin.value = priceMax.value;
      }
      updateLabels();
    });
    priceMax?.addEventListener('input', () => {
      if (priceMin && parseInt(priceMax.value) < parseInt(priceMin.value)) {
        priceMax.value = priceMin.value;
      }
      updateLabels();
    });

    function applyFilters() {
      const min = priceMin ? parseFloat(priceMin.value) : 0;
      const max = priceMax ? parseFloat(priceMax.value) : Infinity;
      const onlyInStock = stockCheckbox ? stockCheckbox.checked : false;

      const cards = grid.querySelectorAll('.product-card[data-price]');
      let visibleCount = 0;

      cards.forEach(card => {
        const price = parseFloat(card.dataset.price || '0');
        const available = card.dataset.available === 'true';
        let show = price >= min && price <= max;
        if (onlyInStock && !available) show = false;
        card.style.display = show ? '' : 'none';
        if (show) visibleCount++;
      });

      // Show/hide "no results" message
      let emptyMsg = grid.querySelector('.filter-empty-message');
      if (visibleCount === 0) {
        if (!emptyMsg) {
          emptyMsg = document.createElement('p');
          emptyMsg.className = 'filter-empty-message';
          emptyMsg.textContent = 'No hay productos que coincidan con estos filtros.';
          grid.appendChild(emptyMsg);
        }
        emptyMsg.style.display = '';
      } else if (emptyMsg) {
        emptyMsg.style.display = 'none';
      }

      // Update results count if present
      const countEl = document.getElementById('filtered-count');
      if (countEl) {
        const total = cards.length;
        countEl.textContent = visibleCount === total
          ? `${total}`
          : `${visibleCount} de ${total}`;
      }

      // Close mobile sidebar after applying
      document.querySelector('.collection-sidebar')?.classList.remove('open');
      document.body.style.overflow = '';
    }

    applyBtn?.addEventListener('click', applyFilters);
    stockCheckbox?.addEventListener('change', applyFilters);
    updateLabels();
  })();

  // ====== GRID TOGGLE ======
  document.querySelectorAll('.grid-toggle__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const cols = btn.dataset.grid;
      const grid = document.getElementById('product-grid');
      if (!grid) return;
      grid.className = `product-grid product-grid--${cols}`;
      document.querySelectorAll('.grid-toggle__btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // ====== BACK TO TOP ======
  const btt = document.getElementById('back-to-top');
  window.addEventListener('scroll', () => {
    btt?.classList.toggle('visible', window.scrollY > 400);
  });
  btt?.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));

  // ====== STICKY HEADER ======
  const header = document.getElementById('site-header');
  window.addEventListener('scroll', () => {
    header?.classList.toggle('scrolled', window.scrollY > 10);
  });

  // ====== ESC KEY ======
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeCart(); closeQV(); closeMobile(); }
  });

})();

// === COLLECTION SIDEBAR ===
(function() {
  var filterBtn = document.getElementById('filter-toggle');
  var sidebar = document.getElementById('collection-sidebar');
  var sidebarOverlay = document.getElementById('sidebar-overlay');
  var sidebarClose = document.getElementById('sidebar-close');

  function openSidebar() {
    if(sidebar) sidebar.classList.add('open');
    if(sidebarOverlay) sidebarOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeSidebar() {
    if(sidebar) sidebar.classList.remove('open');
    if(sidebarOverlay) sidebarOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if(filterBtn) filterBtn.addEventListener('click', openSidebar);
  if(sidebarClose) sidebarClose.addEventListener('click', closeSidebar);
  if(sidebarOverlay) sidebarOverlay.addEventListener('click', closeSidebar);
})();
